
import XHeader from 'vux/src/components/x-header/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'


export default {
components: {
XHeader,
Group,
XInput,
XButton
},
data() {
return {
number: '',
code: '',
readonly: false,

submitBtnText: '提交',

getCodeBtnText: '获取验证码',
canNotGetCode: true
}
},
created: function () {
document.title = '设置手机号码'
this.countDown()
},
computed: {
canNotSubmit: function () {

return !(this.code.length === 6 && this.readonly === true);
}
},
methods: {
getCode() {
if (this.number.length !== 11) {
this.$vux.toast.show({
text: '请先输入手机号',
type: 'cancel'
});
return;
}


this.$http.post(this.tianYiWebUrl + '/wechat/mobile/ajaxSendVerificationCode', {mobile: this.number}).then(r => {
let type;
let res = r.data
if (res.code === 200) {
type = 'success';
localStorage.setItem('countdown', new Date().getTime())
this.readonly = true
this.countDown()
} else {
type = 'cancel';
}
this.$vux.toast.show({
text: res.message,
type: type
});
})
},
countDown() {
let during = 61;
let lastGetCodeTime = localStorage.getItem('countdown');
let diff = during - Math.floor((new Date().getTime() - lastGetCodeTime) / 1000);
if (lastGetCodeTime === null) {
this.canNotGetCode = false;
return;
}
if (diff > 0) {
let sec = diff;
let _this = this
for (let i = 0; i <= diff; i++) {
window.setTimeout(function () {
if (sec != 0) {
_this.canNotGetCode = true
_this.getCodeBtnText = sec + " 秒后重发验证";
sec--;
} else {
_this.getCodeBtnText = '获取验证码'
_this.canNotGetCode = false
}
}, i * 1000)
}
} else {
this.getCodeBtnText = '获取验证码'
this.canNotGetCode = false
}

},
submit() {
if (this.number.length !== 11) {
this.$vux.toast.show({
text: '请输入11位手机号码',
type: 'cancel'
});
return;
}
if (this.code.length !== 6) {
this.$vux.toast.show({
text: '请输入6位验证码',
type: 'cancel'
});
return;
}
this.$http.post(this.tianYiWebUrl + '/wechat/mobile/ajaxValidateCode', {
params: {
mobile_number: this.number,
verify_number: this.code
}
}).then(r => {
let res = r.data
if (res.code === 200) {
var type = 'success'
} else {
var type = 'cancel'
}
this.$vux.toast.show({
text: res.message,
type: type
});


if (res.code === 200) {
this.$router.push('/uc/setting')
}
})
},
}
}



// WEBPACK FOOTER //
// ./src/components/uc/SetMobile.vue